import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { makeStyles } from '@material-ui/core/styles'

import Divider from '@material-ui/core/Divider'

import Header from 'components/quote/Header'
import QuoteTable from 'components/quote/Table'
import ResourceFinder from 'pages/resource/Finder'
import SimpleTableDeleteDialog from 'components/table/SimpleTableDeleteDialog'

import selectors from 'store/selectors'
import quoteActions from 'store/modules/quote'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  header: {
    flexGrow: 0,
  },
  table: {
    padding: theme.spacing(),
    height: '100%',
    flexGrow: 1,
    overflowY: 'auto',
  },
  previewPDFContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'center',
  },
  previewPDF: {
    width: '21cm',
    height: '29.7cm',
  }
}))

const QuoteTasks = ({

}) => {
  const classes = useStyles()
  const dispatch = useDispatch()

  const route = useSelector(selectors.router.route)
  const quote = useSelector(selectors.quote.collection.item)
  const folderid = useSelector(selectors.quote.folderid)
  const tree = useSelector(selectors.quote.tree)
  const folderPath = useSelector(selectors.quote.folderPath)
  const currentFolder = useSelector(selectors.quote.currentFolder)
  const rows = useSelector(selectors.quote.rows)
  const markups = useSelector(selectors.quote.markups)
  const totals = useSelector(selectors.quote.totals)
  const inputVat = useSelector(selectors.quote.inputVatField)
  const inputMarkups = useSelector(selectors.quote.inputMarkupFields)
  const edits = useSelector(selectors.quote.edits)
  const inputs = useSelector(selectors.quote.inputs)
  const currency = useSelector(selectors.project.currency)
  const expanded = useSelector(selectors.quote.expanded)
  const taskWindowParent = useSelector(selectors.quote.taskWindowParent)
  const deleteItem = useSelector(selectors.quote.deleteItem)
  const editName = useSelector(selectors.quote.editName)
  const sortMode = useSelector(selectors.quote.sortMode)
  const clientView = useSelector(selectors.quote.clientView)
  const readOnly = useSelector(selectors.quote.readOnly)

  const onViewFolder = (id) => dispatch(quoteActions.viewFolder(id))
  const onAddItem = (payload) => dispatch(quoteActions.addItem(payload))
  const onDeleteItem = (payload) => dispatch(quoteActions.deleteItem(payload))
  const onExpand = (payload) => dispatch(quoteActions.setExpanded(payload))
  const onSwapLinkChildren = (payload) => dispatch(quoteActions.swapLinkChildren(payload))
  const onSwapFolderChildren = (payload) => dispatch(quoteActions.swapFolderChildren(payload))
  const onChange = (payload) => dispatch(quoteActions.addChange(payload))
  const onUpdateEditName = (payload) => dispatch(quoteActions.setEditName(payload))
  const onCommitEditName = (payload) => dispatch(quoteActions.commitEditName(payload))
  const onResetEditName = (payload) => dispatch(quoteActions.resetEditName(payload))
  const onSetSortMode = (payload) => dispatch(quoteActions.setSortMode(payload))
  const onSetClientView = (payload) => dispatch(quoteActions.setClientView(payload))
  const onSetInput = (payload) => dispatch(quoteActions.onSetInput(payload))
  const onSetQuoteInput = (payload) => dispatch(quoteActions.onSetQuoteInput(payload))
  const onSetQuoteEdit = (payload) => dispatch(quoteActions.onSetQuoteEdit(payload))
  const onSetEdit = (payload) => dispatch(quoteActions.onSetEdit(payload))
  const onExportPDF = () => dispatch(quoteActions.exportPDF())
  
  const onExpandChildren = (id, type) => dispatch(quoteActions.setExpandedChildren({
    id,
    value: true,
    type,
  }))
  const onContractChildren = (id) => dispatch(quoteActions.setExpandedChildren({
    id,
    value: false,
  }))
  const onOpenDeleteWindow = (item) => dispatch(quoteActions.setDeleteItem(item))
  const onCloseDeleteWindow = () => dispatch(quoteActions.setDeleteItem(null))
  const onOpenTaskWindow = (id) => dispatch(quoteActions.setTaskWindowParent(id))
  const onCloseTaskWindow = () => dispatch(quoteActions.setTaskWindowParent(null))

  console.dir(rows)
  if(!currentFolder) {
    return (
      <div>folder { folderid } not found</div>
    )
  }

  return (
    <div className={ classes.root }>
      <div className={ classes.header }>
        <Header
          addEnabled
          route={ route }
          quote={ quote }
          folderid={ folderid }
          folderPath={ folderPath }
          currentFolder={ currentFolder }
          sortMode={ sortMode }
          readOnly={ readOnly }
          clientView={ clientView }
          onViewFolder={ onViewFolder }
          onAddItem={ onAddItem }
          onOpenTaskWindow={ onOpenTaskWindow }
          onOpenDeleteWindow={ onOpenDeleteWindow }
          onExpandChildren={ onExpandChildren }
          onContractChildren={ onContractChildren }
          onSetSortMode={ onSetSortMode }
          onSetClientView={ onSetClientView }
          onExportPDF={ onExportPDF }
        />
        <Divider />
      </div>
      <div className={ classes.table }>
        <QuoteTable
          quote={ quote }
          tree={ tree }
          folderid={ folderid }
          rows={ rows }
          markups={ markups }
          totals={ totals }
          inputVat={ inputVat }
          inputMarkups={ inputMarkups }
          currency={ currency }
          edits={ edits }
          inputs={ inputs }
          expanded={ expanded }
          sortMode={ sortMode }
          clientView={ clientView }
          readOnly={ readOnly }
          editName={ editName }
          onExpand={ onExpand }
          onAddItem={ onAddItem }
          onOpenTaskWindow={ onOpenTaskWindow }
          onOpenDeleteWindow={ onOpenDeleteWindow }
          onExpandChildren={ onExpandChildren }
          onContractChildren={ onContractChildren }
          onSwapLinkChildren={ onSwapLinkChildren }
          onSwapFolderChildren={ onSwapFolderChildren }
          onChange={ onChange }
          onUpdateEditName={ onUpdateEditName }
          onCommitEditName={ onCommitEditName }
          onResetEditName={ onResetEditName }
          onSetInput={ onSetInput }
          onSetEdit={ onSetEdit }
          onSetQuoteInput={ onSetQuoteInput }
          onSetQuoteEdit={ onSetQuoteEdit }
        />
      </div>
      <ResourceFinder
        open={ taskWindowParent ? true : false }
        title="Add"
        onCancel={ onCloseTaskWindow }
        onSave={ (resource) => {
          onAddItem({
            parent: taskWindowParent,
            type: 'task',
            resource,
          })
        }}
      />
      <SimpleTableDeleteDialog
        open={ deleteItem ? true : false }
        title={ deleteItem ? `${deleteItem.resource.name}` : null }
        onCancel={ onCloseDeleteWindow }
        onConfirm={ () => onDeleteItem({id: deleteItem.id}) }
      />
    </div>
  )
}

export default QuoteTasks